import { EnvConfig } from "./envconfig";

export const environment: EnvConfig = {
  production: true,
  sbdBaseUrl: 'https://staging-ap-dev.suretybondsdirect.com',
  apiBaseUrl: 'https://staging-ap-dev.suretybondsdirect.com/admin',
  dougV2BaseUrl: 'https://staging-ap-dev.suretybondsdirect.com',
  titleBase: '(APDEV) Doug',
  shouldCathyBeChatty: true
};
